import "../assets/common4.css";
import { c as n } from "./index.bddf5ebb.js";
const b = "_modal_6fiog_7", _ = "_dismiss_6fiog_50", u = "_header_6fiog_60", m = "_heading_6fiog_96", g = "_description_6fiog_107", f = "_body_6fiog_111", x = "_content_6fiog_118", h = "_footer_6fiog_134", p = "_column_6fiog_139", v = "_side_6fiog_152", y = "_small_6fiog_177", w = "_large_6fiog_183", C = "_fixedFooter_6fiog_188", o = {
  modal: b,
  dismiss: _,
  header: u,
  heading: m,
  description: g,
  body: f,
  content: x,
  footer: h,
  column: p,
  side: v,
  small: y,
  large: w,
  fixedFooter: C
}, R = ({
  className: t,
  fixedFooter: s,
  size: e,
  position: i
}) => n([o.modal, t], {
  [o.fixedFooter]: !!s,
  [o[e] || ""]: e !== "medium",
  [o[i] || ""]: i !== "center"
}), N = ({ bodyClassName: t }) => n(o.body, t), S = ({
  contentClassName: t
}) => n(o.content, t), k = ({
  dismissClassName: t
}) => n(o.dismiss, t), G = ({ isColumnMode: t }) => n(o.footer, {
  [o.column]: !!t
}), j = (t) => {
  if (window.innerWidth >= 768 && t) {
    const s = t.getBoundingClientRect(), e = Array.from(t.children), i = Number.parseFloat(window.getComputedStyle(t).gap || "0"), d = e.reduce((r, c) => {
      const l = c.getBoundingClientRect();
      return r + l.width;
    }, 0), a = s.width - 2 * Number.parseFloat(window.getComputedStyle(t).paddingInline);
    return d + (e.length - 1) * i > a;
  }
  return !1;
}, A = `
  a[href]:not([tabindex="-1"]),
  area[href]:not([tabindex="-1"]),
  input:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  button:not([disabled]):not([tabindex="-1"]),
  iframe:not([tabindex="-1"]),
  object:not([tabindex="-1"]),
  embed:not([tabindex="-1"]),
  [contenteditable]:not([contenteditable="false"]),
  [tabindex]:not([tabindex="-1"]),
  audio[controls]:not([tabindex="-1"]),
  video[controls]:not([tabindex="-1"]),
  summary:not([tabindex="-1"]),
  svg[focusable="true"]:not([tabindex="-1"]),
  div[role="button"]:not([tabindex="-1"]),
  div[role="checkbox"]:not([tabindex="-1"]),
  div[role="link"]:not([tabindex="-1"]),
  div[role="menuitem"]:not([tabindex="-1"]),
  div[role="option"]:not([tabindex="-1"]),
  div[role="radio"]:not([tabindex="-1"]),
  div[role="switch"]:not([tabindex="-1"]),
  div[role="tab"]:not([tabindex="-1"])
`;
export {
  S as a,
  N as b,
  j as c,
  k as d,
  G as e,
  A as f,
  R as g,
  o as s
};
//# sourceMappingURL=common.403a14df.js.map
